import { useEffect } from 'react';
import { allSettled, Event } from 'effector';
import { useUnit } from 'effector-react';
import {
  $column,
  $order,
  $sortingReady,
  createSortToolbarScope,
  setConfig,
  SortToolbarGate,
} from '../../model';
import { SortConfig } from '../../types';
import { SortMenu } from '../menu';

export type Props = {
  config: SortConfig;
  outerSortChanged: Event<{ field: string; sort?: 'asc' | 'desc' | null }[]>;
  sortingReadyChanged: Event<boolean>;
};

export const SortToolbarBody = ({ config, outerSortChanged, sortingReadyChanged }: Props) => {
  const scope = createSortToolbarScope(config.id);
  const [column, order, sortingReady] = useUnit([$column, $order, $sortingReady]);

  useEffect(() => {
    const init = async () => {
      await allSettled(setConfig, {
        scope,
        params: config,
      });
    };

    init();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const resolveOuterSortChanged = () => {
      if (column === null && order) return;
      if (order === null && column) return;

      if (column === null && order === null) {
        outerSortChanged([]);
      }

      if (column !== null && order !== null) {
        outerSortChanged([
          {
            field: column,
            sort: order,
          },
        ]);
      }
    };

    resolveOuterSortChanged();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [column, order]);

  useEffect(() => {
    sortingReadyChanged(sortingReady)
  }, [sortingReadyChanged, sortingReady]);

  return (
    <>
      <SortToolbarGate />

      <SortMenu />
    </>
  );
};
